<mbs-card-group>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.useCredentials"
      [formControl]="useCredentials"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.useCredentials' | i18next"></mbs-checkbox>
  </mbs-form-group>

  <ng-container *ngTemplateOutlet="credentials"></ng-container>
</mbs-card-group>

<ng-template #credentials>
  @if (useCredentials.value) {
    <mbs-form-group>
      <mbs-input
        [attr.data-e2e]="e2eLocators.user"
        [boldLabel]="true"
        [formControl]="user"
        [label]="'shared:common.user' | i18next: { format: 'capitalize' }"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.username' | i18next"
        [showRequiredMark]="false"></mbs-input>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-input-password
        [attr.data-e2e]="e2eLocators.password"
        [autocomplete]="'new-password'"
        [boldLabel]="true"
        [disabledEye]="password.value === fakeSecretKey"
        [formControl]="password"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.password' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.password' | i18next"
        [showRequiredMark]="false"></mbs-input-password>
    </mbs-form-group>
  }
</ng-template>
